<template>
    <div class='view view--product'>
        <div class='view__content' data-scroll-section>
            <transition name='vue-fade'>
                <Spinner
                    v-if='!product'
                    :variants='["large", "fixed"]'
                />

                <ProductTier
                    v-else
                    id='product'
                    :product='product'
                    :features='features'
                    :linkedProducts='linkedProducts'
                    :ctaTextOverride='ctaTextOverride'
                    :ctaUrlOverride='ctaUrlOverride'
                    :ctaTextOverrideAlways='ctaTextOverrideAlways'
                    :ctaHideIfSoldout='ctaHideIfSoldout'
                    :downloadableType='downloadableType'
                    :downloadableFile='downloadableFile'
                    :waitlistId='waitlistId'
                    :sizeChart='sizeChart'
                    :cartNotice='cartNotice'
                    data-scroll-id='product'
                    data-scroll
                />
            </transition>
        </div>

        <div data-scroll-section>
            <Footer id='footer' data-scroll-id='footer' data-scroll />
        </div>
    </div>
</template>


<script>
import Spinner from '^/components/elements/Spinner.vue'
import ProductTier from '^/components/tiers/ProductTier.vue'
import Footer from '^/components/Footer.vue'

export default {
    name: 'ProductPreviewView',
    data: () => ({
        product: window.app?.productData?.product || null,
        features: window.app?.productData?.features || [],
        linkedProducts: window.app?.productData?.linked_products || [],
        ctaTextOverride: window.app?.productData?.cta_text_override || '',
        ctaUrlOverride: window.app?.productData?.cta_url_override || '',
        ctaTextOverrideAlways: window.app?.productData?.cta_text_override_always || false,
        ctaHideIfSoldout: window.app?.productData?.cta_hide_if_soldout || false,
        downloadableType: window.app?.productData?.downloadable_type || '',
        downloadableFile: window.app?.productData?.downloadable_file || '',
        waitlistId: window.app?.productData?.waitlist_id || '',
        sizeChart: window.app?.productData?.size_chart || null,
        cartNotice: window.app?.productData?.cart_notice || '',
    }),
    components: {
        Spinner,
        ProductTier,
        Footer
    }
};
</script>
